import "./feature-comparison-block.scss";